// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "public/css/" + chunkId + "." + {"3948":"23b0ffda742fccdd2270","9329":"e978a7f238c0dd0e5a3c"}[chunkId] + ".css";
};